/**
 * @name v0.0.8版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2020-4-21
 * 
*/
// 导入v0.0.5数据格式
import * as v007 from './v007.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    /** 
     * 如果当前版本为v0.0.8,则该数据不需要更新直接抛出,
     * 否则先将数据格式化为v0.0.7数据在进行处理
     *
    **/
    if ( version == '0.0.8') return formData;
    // 把数据按照v005版本格式化数据，然后在进行处理
    let currentData = v007.upgrade(formData);
    // 取出表单项字典,给需要添加showRule(显示设置)配置的表单项添加该配置
    let { formMap={} } = currentData;
    // 需要添加seat配置的组件类型列表
    let includeSeat = ['text','input','textarea'];
    // 添加配置
    for ( let key in formMap) {
        let { type } = formMap[key].node;
        // 添加默认配置
        includeSeat.includes(type) && (formMap[key].renderOption.seat = '');
        type == 'button' && (formMap[key].baseOption.clicked = false);
    }
    // 版本号更新
    currentData.version = '0.0.8';
    return currentData;
}



// WEBPACK FOOTER //
// ./src/assets/version/v008.js